import { Tooltip } from '@televet/kibble-ui/build/components/Tooltip';
import { SemanticBackgroundColorToken } from '@televet/kibble-ui/build/theme/tokens';
import React from 'react';
import {
  StripeDisputeStatus,
  StripeInvoiceStatus,
  StripePaymentIntentStatus,
  StripePayoutStatus,
} from 'shared/types/graphql';
import StatusTag from '../components/StatusTag';
import { StatusDescription } from '../records/status.records';
import { DisplayType } from '../types';

export const dataPlaceholder: Record<DisplayType, string> = {
  Interactive: '--',
  Download: ' ',
};

export const getStatusComponent = ({
  status,
  tooltipText,
}: {
  status: string;
  tooltipText?: string | null;
}): JSX.Element => {
  const label = StatusDescription[status];
  let backgroundColor: SemanticBackgroundColorToken = 'background.default';
  switch (status) {
    case StripePaymentIntentStatus.Canceled:
    case StripePaymentIntentStatus.RequiresAction:
    case StripePaymentIntentStatus.RequiresConfirmation:
    case StripeDisputeStatus.ChargeRefunded:
    case StripeDisputeStatus.Lost:
    case StripeDisputeStatus.NeedsResponse:
    case StripeDisputeStatus.WarningNeedsResponse:
    case StripePayoutStatus.Canceled:
    case StripePayoutStatus.Failed:
    case StripeInvoiceStatus.Uncollectible:
    case StripeInvoiceStatus.Void:
    case 'Refund':
      backgroundColor = 'background.danger';
      break;
    case StripePaymentIntentStatus.Created:
    case StripePaymentIntentStatus.Processing:
    case StripePaymentIntentStatus.RequiresCapture:
    case StripePaymentIntentStatus.RequiresPaymentMethod:
    case StripeDisputeStatus.UnderReview:
    case StripeDisputeStatus.WarningClosed:
    case StripeDisputeStatus.WarningNeedsResponse:
    case StripeDisputeStatus.WarningUnderReview:
    case StripePayoutStatus.InTransit:
    case StripePayoutStatus.Pending:
    case StripeInvoiceStatus.Draft:
    case StripeInvoiceStatus.Open:
      backgroundColor = 'background.warning';
      break;
    case StripePaymentIntentStatus.Succeeded:
    case StripeDisputeStatus.Won:
    case StripeDisputeStatus.WarningClosed:
    case StripePayoutStatus.Paid:
    case StripeInvoiceStatus.Paid:
      backgroundColor = 'background.success';
      break;
    default:
      break;
  }

  const component = <StatusTag label={label} bg={backgroundColor} />;

  return tooltipText ? <Tooltip label={tooltipText}>{component}</Tooltip> : component;
};
